// @mui
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
// components
import { useProduct } from 'src/sections/product/hooks';
import Iconify from 'src/components/iconify';
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
import Badge from '@mui/material/Badge';
import { m } from 'framer-motion';
import { varHover } from 'src/components/animate';

// ----------------------------------------------------------------------

export default function CardButton() {
  const { checkout } = useProduct();
  const { totalItems } = checkout;

  return (
    <Box component={RouterLink} href={paths.product.checkout}>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        aria-label="mode"
        sx={{
          width: 40,
          height: 40,
        }}
      >
        <Badge showZero badgeContent={totalItems} color="warning" max={99}>
          <Iconify icon="solar:cart-3-bold" width={24} />
        </Badge>
      </IconButton>
    </Box>
  );
}
